<template>
  <div>
    <div>
      <!-- 已结算 -->
      <div class="search">
        <div class="search_box">
          <div class="searchItem">
            <div class="label">项目编号</div>
            <div class="field">
              <el-input v-model.trim="query.projectcode" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">项目名称</div>
            <div class="field">
              <el-input v-model.trim="query.projectname" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">业务员</div>
            <div class="field">
              <el-input v-model.trim="query.ptcname" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
            <div class="label">项目员</div>
            <div class="field">
              <el-input v-model.trim="query.cusername" clearable></el-input>
            </div>
          </div>
          <div class="searchItem">
              <div class="label">采购人</div>
              <div class="field">
                <el-input v-model.trim="query.acomname" clearable></el-input>
              </div>
          </div>
          <div class="searchItem">
            <div class="label">结算日</div>
            <div class="field" style="width: 400px">
              <el-date-picker
                v-model="query.settleStartTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
              <div style="margin: 0 10px">至</div>
              <el-date-picker
                v-model="query.settleEndTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="searchItem">
            <div class="search_btn">
              <el-button type="primary" @click="search">查询</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vggrid
      :random="Math.floor(Math.random() * 999999)"
      :list="list"
      tableheight="400"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :defaultPage="10"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
    >
      <template slot="btn">
        <span>共 {{ query.total }} 个项目，结算金额合计{{ amt.fwfprice | Thousands }}元</span>
      </template>
    </vggrid>
  </div>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import vggrid from "../../views/common/vggrid";
import dayjs from "dayjs";
export default {
  name: "settledXMYTab",
  data() {
    return {
      cols: [
        {
          field: "projectcode",
          fieldtype: "I",
          title: "项目编号",
          calculExpr: "",
        },
        {
          field: "projectname",
          fieldtype: "I",
          title: "项目名称",
          calculExpr: "",
        },
        {
          field: "Pcomname",
          fieldtype: "I",
          title: "采购人",
          calculExpr: "",
        },
        {
          field: "projectlimitamt",
          fieldtype: "I",
          title: "预算额（元）",
          calculExpr: "",
        },
        {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "pusername",
          fieldtype: "I",
          title: "项目员",
          calculExpr: "",
        },
        {
          field: "confirmfeeamt",
          fieldtype: "I",
          title: "服务费（元）",
          calculExpr: "",
        },
        {
          field: "psufewreceivetime",
          fieldtype: "I",
          title: "收取日",
          calculExpr: "",
        },
        {
          field: "psupmrewardmoney",
          fieldtype: "I",
          title: "结算金额（元）",
          calculExpr: "",
        },
        {
          field: "psupmrewardtime",
          fieldtype: "I",
          title: "结算日",
          calculExpr: "",
        },
        {
          field: "psupmrewardename",
          fieldtype: "I",
          title: "结算人",
          calculExpr: "",
        },
      ],
      list: [],
      amt: {},
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        total: 0,
        limit: 10,
        offset: 0,
      },
    };
  },
  components: { vggrid },
  async activated() {
    await this.getPerformance();
  },
  props: {
    activeName: {},
  },
  watch: {
    async activeName() {
      this.list = [];
      if (this.activeName === "third") {
        await this.getPerformance();
      }
    },
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  methods: {
    search() {
      this.query.offset = 0
      this.query.limit = 15
      this.query.total = 0
      this.query.offset = 0
      this.getPerformance();
    },
    async getPerformance() {
      this.query.settleEndTime_c = this.query.settleEndTime
        ? dayjs(this.query.settleEndTime).add(1, "day").format("YYYY-MM-D")
        : null;
      this.query.isMyself = 0;
      this.query.salerewardflg = 1;
      let res = await request({
        url: "/basic/statisticalAnalysis/getXMYAlreadyPerformance",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        e.psufewreceivetime = utils.formatterDate(
          e.psufewreceivetime,
          "yyyy-MM-dd"
        );
        e.psupmrewardtime = utils.formatterDate(
          e.psupmrewardtime,
          "yyyy-MM-dd"
        );
        e.projectlimitamt = utils.comdify( e.projectlimitamt)
        e.confirmfeeamt = utils.comdify( e.confirmfeeamt)
        e.psupmrewardmoney = utils.comdify( e.psupmrewardmoney)
        return e;
      });
      this.list = res.data;
      this.query.total = res.count[0].count;
      this.amt = res.amt;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPerformance();
    },
    async cellClick(row) {
      this.model = row;
    },
    async viewProject(row) {
      this.model = row;
    },
  },
};
</script>

<style scoped>
</style>
